import type { Point } from "highcharts";

import type { BacklinksFollowType, BacklinksQueryStatusType } from "@similarweb/pro-api-client";

import type { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

/* eslint-disable @typescript-eslint/naming-convention */
export const enum DataStates {
    LOADING,
    LOADED,
    ERROR,
    NO_DATA,
    PARTIAL_DATA,
}

export interface IBacklinksTable {
    handleOpenQualificationSideBar?: (e: any) => void;
}

export interface PaginatedResponse<T> {
    TotalRecords: number;
    Records: T[];
    Page: number;
    PageSize: number;
}

export interface IHighChartTooltip {
    timeGranularity: GranularityNames;
    lastSupportedDate?: string;
    points?: Point[];
    meta: object;
    x: number;
}

export interface BacklinksErrorResponse {
    Type: string;
    Title: string;
    Status: number;
    Extensions: {
        traceId: string;
    };
}

export interface BacklinkExpectedURLParams {
    country?: string | number;
    status?: BacklinksQueryStatusType;
    follow?: BacklinksFollowType;
    dtsFrom?: string;
    dtsTo?: string;
    key?: string;
    url?: string;
    asc?: "true" | "false";
    sort?: string;
    // This one expected to be a stringified JSON array
    pageFilter?: string;
    duration?: string;
    brokenOnly?: "true" | "false";
    targetUrl?: string;
    // JSON field
    includeExclude?: string;
}
